import {serverApi} from './RestService';
import {ArticleMarketplaceStatus} from "../interfaces/response/MarketplaceStatus";

/**
 * Service per il monitoraggio dello stato degli articoli sui marketplace.
 * Utilizza la baseQuery configurata in RestService (serverApi).
 */

const marketplaceService = serverApi.injectEndpoints({
    endpoints: builder => ({
        /**
         * Recupera lo stato di tutti gli articoli per tutti i marketplace.
         * @param forceRefresh - Se true, bypassa la cache (attualmente ignorato, il backend non ha cache)
         */
        getMarketplaceStatus: builder.query<ArticleMarketplaceStatus[], boolean>({
            query: (forceRefresh) => 'api/marketplace-status',
            transformResponse: (response: ArticleMarketplaceStatus[]) => response,
        }),
        
        /**
         * Forza il refresh dei feed marketplace.
         */
        refreshMarketplaceFeeds: builder.mutation<string, void>({
            query: () => ({
                url: 'api/marketplace-status/refresh-feeds',
                method: 'POST',
            }),
        })
    })
});

export const {
    useGetMarketplaceStatusQuery,
    useLazyGetMarketplaceStatusQuery,
    useRefreshMarketplaceFeedsMutation
} = marketplaceService;
